'use strict';

import '../css/pages/faq.scss';
import Accordion from "./Accordion/Accordion";
import {documentReady} from "./Shared/DocumentReady";

documentReady(() => {
    window.super();
    new Accordion();
});
